<template>
  <div>
    <Report
      module="Estoque"
      name="Historico de Patrimonios"
      urlGet="/api/v1/stock/report/history-patrimony"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportHistoryPatrimonyView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Patrimonio",
          field: "barCode",
          fieldOrderBy: "BarCode",
          show: true,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Data",
          field: "registeredDate",
          fieldOrderBy: "RegisteredDate",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Produto",
          field: "fullName",
          fieldOrderBy: "FullName",
          show: true,
          styleHeader: "width:300px;",
          styleBody:
            "max-width: 290px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Status",
          field: "statusMovimentName",
          fieldOrderBy: "StatusMovimentName",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Nº Locacao",
          field: "numberRent",
          fieldOrderBy: "NumberRent",
          show: true,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Cliente",
          field: "customerName",
          fieldOrderBy: "CustomerName",
          show: true,
          styleHeader: "width:240px;",
          styleBody:
            "max-width: 230px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
      ],
      filters: [
        {
          type: "date",
          title: "Periodo",
          field: "RegisteredDate",
          value: "",
          required: true,
        },
        {
          type: "text",
          title: "Patrimonio",
          field: "BarCode",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Produto",
          field: "FullName",
          url: "/api/v1/stock/product/select-all-with-typeProduct",
          propsParams: {},
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "StatusMovimentName",
          options: [
            { text: "Saida", value: "Saida" },
            { text: "Retorno", value: "Retorno" },
          ],
          value: [],
        },
        {
          type: "text",
          title: "Nº Locacao",
          field: "NumberRent",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: { isCustomer: true, isSupplier: false },
          value: "",
        },
      ],
    };
  },
};
</script>
